import apiClient from './api';

export const verificationService = {
  // 검증 후보 추출 (Step 1)
  extractCandidates(file) {
    const formData = new FormData();
    formData.append('file', file);

    return apiClient.post('/verify/extract-candidates', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 7200000, // 타임아웃
    });
  },

  // 검증 수행 (Step 2)
  verifySentences(selectedIds, jsonFilePath) {
    // 전체 경로에서 파일명만 추출
    const fileName = jsonFilePath.split('/').pop();
    
    console.log('📤 전송 데이터:', {
      selected_ids: selectedIds,
      json_file_path: fileName
    });
    
    return apiClient.post('/verify/verify-sentences', {
      selected_ids: selectedIds,
      json_file_path: fileName,
    }, {
      timeout: 7200000, // 타임아웃
    });
  },
};
